export const parseCsv = (v: string | null) =>
  v
    ? v
        .split(",")
        .map((x) => x.trim())
        .filter(Boolean)
    : [];

export const writeCsv = (
  sp: URLSearchParams,
  key: string,
  values: string[] | number[],
) => {
  if (!values.length) sp.delete(key);
  else sp.set(key, values.join(","));
};
